import Color from 'color';
import styled from 'styled-components';
import { lFColor0 } from 'pages/components/LFHeader/LFHeader.styled';
import type { ReportContextStanding } from './reportContextUsers';

const goodInk = '#166534';
const incidentInk = '#c2410c';
const alertInk = '#9f1239';
const neutralInk = '#3f4a5a';

export const Thumb = styled.img<{ $size: number, $onDark?: boolean }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background: ${({ $onDark }) => ($onDark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.06)')};
`;

export const Fallback = styled.span<{
  $size: number,
  $standing?: ReportContextStanding,
  $onDark?: boolean,
}>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ $size }) => Math.max(10, Math.round($size * 0.42))}px;
  font-weight: 700;
  background: ${({ $onDark, $standing }) => {
    if ($onDark) return Color(lFColor0).alpha(0.28).toString();
    if ($standing === 'alert') return Color(alertInk).alpha(0.12).toString();
    if ($standing === 'incident') return Color(incidentInk).alpha(0.12).toString();
    if ($standing === 'good') return Color(goodInk).alpha(0.12).toString();
    return Color(neutralInk).alpha(0.12).toString();
  }};
  color: ${({ $onDark, $standing }) => {
    if ($onDark) return Color(lFColor0).mix(Color('#ffffff'), 0.88).hex();
    if ($standing === 'alert') return alertInk;
    if ($standing === 'incident') return incidentInk;
    if ($standing === 'good') return goodInk;
    return neutralInk;
  }};
`;
